import request from "../util/request";
import {GetGoodsCategoriesParams, GoodsCategoriesItemInterface} from "@/lib/type/goods-categories.type";
import {GetProductByCategory, GetProductDetail, GetStatus} from "@/lib/type/product.type";
import {GetStatusType, ProductByCategoryListType, ProductByCategoryPagesType} from "@/lib/type/product-center";


// 获取商品分类
export const requestGetGoodsCategory = (params: GetGoodsCategoriesParams) => request<{
    list: GoodsCategoriesItemInterface[]
}>({
    endpoint: "/api/tiny-shop/v1/product/cate/index",
    cache: "no-cache",
    params
});


//根据商品分类获取产品
export const requestCategoryProducts = (params: GetProductDetail) => request<{
    list: any
}>({
    endpoint: "/api/tiny-shop/v1/product/cate/attributes",
    cache: "no-cache",
    params
});

//根据商品分类获取产品
export const requestProductByCategory = (params:GetProductByCategory) => request<{
    list: ProductByCategoryListType[],
    pages:ProductByCategoryPagesType
}>({
    endpoint: "/api/tiny-shop/v1/product/product/list",
    cache: "no-cache",
    params
});

export const requestGetStatus = (params:GetStatus) => request<GetStatusType>({
    endpoint: "/api/tiny-shop/v1/product/cate/attributes",
    cache: "no-cache",
    params
});